import {Component, ElementRef, EventEmitter, forwardRef, HostBinding, Input, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DomHandler} from 'primeng/primeng';

const componentBaseName = 'input-text';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

export const INPUT_TEXT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputTextComponent),
  multi: true,
};

const FIELD_TYPE = {
  Number: 'number',
  Text: 'text',
};

/**
 * A component to display a normalized version for a label / text input pair
 */
@Component({
  selector: 'cat-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [INPUT_TEXT_VALUE_ACCESSOR, DomHandler],
})
export class InputTextComponent implements ControlValueAccessor {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() description: string;
  @Input() placeholder: string = '';
  @Input() hideLabel: boolean = false;
  @Input() inline: boolean = false;

  @Input() style: any;
  @Input() type = FIELD_TYPE.Text;

  @Input() styleClass: string;

  @Input() tabindex: number;

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputField') inputField: ElementRef;

  model: any;
  // private onModelChange: (value) => {};
  // private onModelTouched: (value) => {};

  constructor(public el: ElementRef, public domHandler: DomHandler) {
  }

  onModelChange(value?: any) {
  }

  onModelTouched(value?: any) {
  }

  writeValue(model: any): void {
    this.model = model;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  onChangeValue($event: any) {

    let inputValue = this.inputField.nativeElement.value;

    if (this.type === FIELD_TYPE.Number) {
      inputValue = parseInt(inputValue, 0);
    }

    this.model = inputValue;
    this.onModelChange(this.model);
    this.onChange.emit({
      originalEvent: $event,
      value: this.model,
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/input-text/input-text.component.ts